<template lang="pug">
  router-link.drawer-item(v-if="item.path" :to="item.path" tag="div" active-class="drawer-item--selected")
    .drawer-item__icon
        img(:src="`/icons/${item.icon}`" width="32" height="32")
    v-fab-transition(mode="out-in")
      .drawer-item__title(v-if="!mini") {{ item.name }}

</template>

<script>
  export default {
    name: 'drawer-item',
    props: {
      item: Object,
      id: Number,
      mini: Boolean
    },
    data () {
      return {
        opened: false,
      }
    },
    computed: {

    },
    methods: {
      
    }
  }
</script>

<style lang="scss" scoped>
$drawer-item-height: 80px;
$drawer-max-width: 280px;
$drawer-item-arrow-size: 24px;

.drawer-item {
  height: $drawer-item-height;
  display: flex;
  align-items: center;
  justify-content: stretch;

  &--selected {
    background: transparentize($color: #C4C4C4, $amount: 0.5);
  }

  &__icon {
    width: 56px;
    padding: 24px 0px 24px 10px;
  }

  &__title {
    //font: $app-drawer-menu-item-font;
    color: #fff;;

    margin-left: 24px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__arrow {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background: #19AFDE;
    cursor: pointer;
  }
}

.expandable-title {
  width: calc(#{$drawer-max-width} - 80px - #{$drawer-item-arrow-size});
}

.small-link {
  //font: normal 16px/20px $roboto;
  color: #505254;

  padding: 10px 10px 10px 80px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &--selected {
    background: #C4C4C4;
  }

  &:hover {
    background: #19AFDE;
    cursor: pointer;
  }
}
</style>